import { createApp } from 'vue'
import { createPinia} from 'pinia'
import App from './App.vue'
import router from './router'
import axiosInstance from './services/api.js'
import ElementUI from 'element-plus'
import TuiPlus from '@wocwin/t-ui-plus'
import VueQrcode from 'vue-qrcode'
import '@wocwin/t-ui-plus/lib/style.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
app.use(TuiPlus)
app.component('vue-qrcode', VueQrcode)

app.config.globalProperties.$axios = axiosInstance
app.config.globalProperties.$globalRouter = router
app.config.globalProperties.$baseFileUrl = 'http://111.35.64.52:30189/api/file?fileUrl=';
app.config.globalProperties.$baseVideoUrl = 'http://111.35.64.52:30189/api/video?videoUrl=';
app.use(router);
app.use(ElementUI)


app.mount('#app')
